export const HEADER_HEIGHT = 68.56;
